export default __webpack_public_path__ + "static/media/javelin.dc8e42b5.gif";